/**
 * 本地 PDF 分层识别服务（/feifan-xxl-art-py/api/import-template-pdf）
 */

import { CDP_ENDPOINTS, cdpEngineAssetUrl, fetchCdpEngineJson } from '@/services/cdpEngineClient';
import { resolveCdpAsset } from '@/utils/platformHelpers';

function normalizeTemplateAsset(asset) {
  if (!asset || typeof asset !== 'string') return asset;
  if (/^(https?:|data:|blob:)/i.test(asset)) return asset;
  return cdpEngineAssetUrl(asset) || resolveCdpAsset(asset);
}

function normalizeImportResult(template = {}) {
  const layerJson = template.layerJson != null && template.layerJson !== ''
    ? (typeof template.layerJson === 'string'
      ? template.layerJson.trim()
      : JSON.stringify(template.layerJson))
    : '';

  return {
    ...template,
    thumb: normalizeTemplateAsset(template.thumb),
    originFileUrl: normalizeTemplateAsset(template.originFileUrl),
    layerJson,
  };
}

export async function importTemplatePdfFromFile(file, options = {}) {
  const formData = new FormData();
  formData.append('pdf', file, file.name);
  formData.append('dpi', String(options.dpi || 180));
  formData.append('storeId', options.storeId || 's1');
  formData.append('name', options.name || file.name || 'template');
  if (options.folderId) formData.append('folderId', options.folderId);

  try {
    const result = await fetchCdpEngineJson(CDP_ENDPOINTS.importTemplatePdf, {
      method: 'POST',
      body: formData,
    }, {
      timeoutMs: 900000,
      fallbackMessage: 'PDF 分层识别失败',
      timeoutMessage: 'PDF 分层识别超时，请检查文件复杂度后重试',
    });
    if (!result.template) {
      throw new Error(result.error || 'PDF 分层识别失败');
    }
    return {
      ...normalizeImportResult(result.template),
      importStats: result.stats || {},
      importWarnings: result.warnings || [],
    };
  } catch (error) {
    if (error instanceof TypeError) {
      throw new Error('PDF 分层服务未启动，请重新运行 npm run dev');
    }
    throw error;
  }
}

export async function recoverTemplateLayersFromOriginUrl(originFileUrl, options = {}) {
  if (!originFileUrl) return null;
  const response = await fetch(originFileUrl);
  if (!response.ok) throw new Error(`读取模版原文件失败: ${response.status}`);
  const blob = await response.blob();
  const encodedName = String(originFileUrl).split('/').pop()?.split('?')[0] || '';
  const sourceName = decodeURIComponent(encodedName) || `${options.name || 'template'}.pdf`;
  const pdfFile = new File([blob], sourceName, { type: blob.type || 'application/pdf' });
  return importTemplatePdfFromFile(pdfFile, options);
}
